/******************************************************************
 * Archivo : client/src/components/Admin/reports/ReportsDashboard/index.js
 * Proyecto: CB30
 * Módulo  : Reportes
 *
 * Propósito:
 * Punto de entrada centralizado para los reportes del sistema.
 *
 * Las opciones se muestran de acuerdo con los permisos asignados
 * al rol del usuario autenticado.
 *
 * Regla:
 * - REPORTES es la functionality del menú.
 * - Los códigos individuales de los permisos determinan qué
 *   opciones aparecen dentro de la pantalla.
 ******************************************************************/

import React from "react";
import { graphql } from "react-apollo";
import { Link } from "react-router-dom";
import _ from "lodash";

// Queries
import fetchAllSurveys from "../../../../queries/fetchAllSurveys";
import fetchUser from "../../../../queries/fetchUser";

const ReportsDashboard = props => {

  const surveyData = props.surveyData;
  const userData = props.userData;

  if (
    !surveyData ||
    surveyData.loading ||
    !userData ||
    userData.loading
  ) {
    return (
      <div className="container">
        <h1>Reportes</h1>
        <p>Cargando reportes...</p>
      </div>
    );
  }

  const user = userData.user;

  if (!user || !user.roles || user.roles.length === 0) {
    return null;
  }

  const permissions = user.roles[0].permissions || [];

  const hasPermission = code =>
    permissions.some(
      permission =>
        permission &&
        permission.active !== false &&
        permission.code === code
    );

  const surveys = surveyData.surveys || [];

  return (
    <div className="container">

      <h1>Reportes</h1>

      {/* =========================================================
          RESULTADO POR ENCUESTA
         ========================================================= */}

      {hasPermission("REPORTES_RESULTADO_ENCUESTA_VER") && (
        <div className="card mb-3">

          <div className="card-body">

            <h5 className="card-title">
              Resultado por encuesta
            </h5>

            <p className="card-text">
              Seleccione una encuesta para consultar sus resultados.
            </p>

            <div>
              <Link
                to="/admin/reportes/resultado-encuesta"
                className="btn btn-primary"
              >
              Abrir reporte
              </Link>
            </div>

          </div>

        </div>
      )}

      {/* =========================================================
          RESULTADO POR USUARIO
         ========================================================= */}

      {hasPermission("REPORTES_RESULTADO_USUARIO_VER") && (
        <div className="card mb-3">

          <div className="card-body">

            <h5 className="card-title">
              Resultado por usuario
            </h5>

            <p className="card-text">
              Consulta de resultados por usuario.
            </p>

            <Link
              to="/admin/visor"
              className="btn btn-primary"
            >
              Abrir visor
            </Link>

          </div>

        </div>
      )}

            {/* =========================================================
          RESULTADO DINÁMICO POR ENCUESTA
         ========================================================= */}

      {hasPermission("REPORTES_DINAMICO_ENCUESTAS_VER") && (
        <div className="card mb-3">

          <div className="card-body">

            <h5 className="card-title">
              Resultado dinámico por encuesta
            </h5>

            <p className="card-text">
              Consulte los resultados de una o varias encuestas
              mediante un visor dinámico.
            </p>

            <div>
              <Link
                to="/admin/visordinamico"
                className="btn btn-primary"
              >
                Abrir visor
              </Link>
            </div>

          </div>

        </div>
      )}

      {/* =========================================================
          EXPORTACIÓN CSV POR ENCUESTA
         ========================================================= */}

      {hasPermission("REPORTES_ENCUESTAS_CSV_EXPORTAR") && (
        <div className="card mb-3">

          <div className="card-body">

            <h5 className="card-title">
              Exportación CSV por encuesta
            </h5>

            <p className="card-text">
              Seleccione una encuesta para realizar la exportación.
            </p>

            <div>
              <Link
                to="/admin/reportes/exportacion-csv-encuesta"
                className="btn btn-primary"
              >
              Abrir reporte
              </Link>
            </div>

          </div>

        </div>
      )}

    </div>
  );
};



export default graphql(fetchUser, {
  name: "userData"
})(
  graphql(fetchAllSurveys, {
    name: "surveyData"
  })(ReportsDashboard)
);


// WEBPACK FOOTER //
// ./src/components/Admin/reports/ReportsDashboard/index.js